<template>
  <div
    :class="['module-layout', `layout-${$route.name}`, { 'layout-top': isTop }]"
  >
    <div class="layout_head">
      <div class="head_logo">
        <a href="https://www.cathayholdings.com/" class="logo_cathayholdings">
          <img
            class="logo_img"
            src="@/pages/cathayfitback/assets/images/layout/logo-holding.webp"
          />
        </a>
        <div class="logo_divider" />
        <a
          href="https://www.cathaylife.com.tw/cathaylife/"
          class="logo_cathaylife"
        >
          <img
            class="logo_img"
            src="@/pages/cathayfitback/assets/images/layout/logo.webp"
          />
        </a>
        <div class="logo_divider" />
        <a href="https://wellness.cathaylife.com.tw/fitback/" class="logo_home">
          <img
            class="logo_img"
            src="@/pages/cathayfitback/assets/images/layout/fitback.webp"
          />
        </a>
      </div>
      <div class="head_nav nav-desktop">
        <a class="nav_link" href="#walk">認識步步攻億走</a>
        <a class="nav_link" href="#step">查看步數</a>
        <a class="nav_link" href="#intro">2026活動介紹</a>
        <a class="nav_link" href="#lookback">歷屆活動回顧</a>
        <a
          class="nav_link"
          href="https://www.cathaylife.com.tw/cathaylife/-/media/19A19A8C6CEA483DB3EB4A349384A955.pdf?sc_lang=zh-TW"
        >
          國泰攻億大聯盟
        </a>
      </div>
      <div class="head_nav nav-mobile">
        <button class="nav_toggle" @click="toggleMenu">
          <template v-if="isMenuOpened">
            <img src="@/pages/cathayfitback/assets/icons/close-gray.svg" />
          </template>
          <template v-else>
            <img src="@/pages/cathayfitback/assets/icons/menu.svg" />
          </template>
        </button>
      </div>
    </div>
    <div class="layout_body">
      <slot />
    </div>
    <a
      id="download"
      class="layout_download"
      href="https://cathaylife.tw/VgA6jo"
    >
      <img
        class="download_img"
        src="@/pages/cathayfitback/assets/images/layout/foot-download.svg"
      />
    </a>
    <div id="foot" class="layout_foot">
      <!-- <div class="foot_logo">
        <img class="logo_img" src="@/pages/cathayfitback/assets/images/layout/logo-holding.webp" />
      </div> -->
      <div class="foot_content">
        <div class="foot_buttonGroup">
          <a
            class="buttonGroup_button"
            target="_blank"
            href="https://www.instagram.com/paytoearth_cathay/?igshid=YmMyMTA2M2Y="
            rel="noreferrer noopenner"
          >
            <img src="@/pages/cathayfitback/assets/icons/foot-ig.svg" />
          </a>
          <a
            class="buttonGroup_button"
            target="_blank"
            href="https://www.facebook.com/Cathaylife"
            rel="noreferrer noopenner"
          >
            <img src="@/pages/cathayfitback/assets/icons/foot-fb.svg" />
          </a>
          <a
            class="buttonGroup_button"
            target="_blank"
            href="https://line.me/R/ti/p/@cathaylife?from=pag"
            rel="noreferrer noopenner"
          >
            <img src="@/pages/cathayfitback/assets/icons/foot-line.svg" />
          </a>
          <a
            class="buttonGroup_button"
            target="_blank"
            href="https://www.youtube.com/user/Cathaylife50"
            rel="noreferrer noopenner"
          >
            <img src="@/pages/cathayfitback/assets/icons/foot-yt.svg" />
          </a>
        </div>
        <p class="foot_copyright">
          版權所有 © 國泰人壽保險股份有限公司 Cathay Life Insurance
        </p>
      </div>
    </div>
    <div id="menu" class="layout_menu">
      <div class="menu_nav">
        <a href="#" @click.prevent="delayMobileMoveTag('walk')">
          <!-- <div :class="['nav_link', { 'link-active': isLookback }]"> -->
          <div :class="['nav_link']">
            <span>認識步步攻億走</span>
            <!-- <span class="link_en">About & History</span> -->
          </div>
        </a>
        <a href="#count" @click.prevent="delayMobileMoveTag('step')">
          <div :class="['nav_link']">
            <span>查看步數</span>
            <!-- <span class="link_en">About & History</span> -->
          </div>
        </a>
        <a href="#fitback" @click.prevent="delayMobileMoveTag('intro')">
          <div :class="['nav_link']">
            <span>2026活動介紹</span>
            <!-- <span class="link_en">About & History</span> -->
          </div>
        </a>
        <a href="#lookback" @click.prevent="delayMobileMoveTag('lookback')">
          <div :class="['nav_link']">
            <span>歷屆活動回顧</span>
            <!-- <span class="link_en">About & History</span> -->
          </div>
        </a>
        <a
          href="https://www.cathaylife.com.tw/cathaylife/-/media/19A19A8C6CEA483DB3EB4A349384A955.pdf?sc_lang=zh-TW"
        >
          <div :class="['nav_link']">
            <span>國泰攻億大聯盟</span>
            <!-- <span class="link_en">About & History</span> -->
          </div>
        </a>
      </div>
      <div class="menu_copyright">
        版權所有 © 國泰人壽保險股份有限公司
        <br />
        <span class="copyright_en">Cathay Life Insurance</span>
      </div>
    </div>
  </div>
</template>

<script>
import { BREAKPOINT } from "@/pages/cathayfitback/assets/definitions";
import { Power1 } from "gsap";

export default {
  name: "moduleLayout",
  data() {
    return {
      windowWidth: window.innerWidth,
      scrollY: window.scrollY,

      BREAKPOINT,

      isMenuOpened: false,
      isShowSos: false
    };
  },
  computed: {
    isTop() {
      return this.scrollY <= 0;
    }
  },
  created() {
    window.addEventListener("scroll", this.updateScrollY);
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.updateScrollY);
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    updateScrollY() {
      this.adjustDownloadPosition();
      this.scrollY = window.scrollY;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    toggleMenu() {
      const menu = document.getElementById("menu");
      if (!this.isMenuOpened) {
        this.gsap.to(menu, {
          duration: 0.5,
          ease: Power1.easeIn,
          opacity: 1,
          top: 50,
          zIndex: 11000
        });
      } else {
        this.gsap.to(menu, {
          duration: 0.5,
          ease: Power1.easeOut,
          opacity: 0,
          top: 0,
          zIndex: -1
        });
      }
      this.isMenuOpened = !this.isMenuOpened;
    },
    adjustDownloadPosition() {
      const foot = document.getElementById("foot");
      const footClientRect = foot.getBoundingClientRect();
      const download = document.getElementById("download");
      if (footClientRect.top <= window.innerHeight) {
        download.style["bottom"] = `${
          window.innerHeight - (footClientRect.top - 20)
        }px`;
      } else {
        download.style["bottom"] = "20px";
      }
    },
    delayMobileMoveTag(tag) {
      this.toggleMenu();
      this.$router.replace({ hash: tag });
      return false;
    }
  },
  watch: {
    "$route.hash": {
      handler: function (hash) {
        if (hash) {
          document
            .getElementById(hash.replace("#", ""))
            .scrollIntoView({ behavior: "smooth" });
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@keyframes moveMobile {
  from {
    top: calc(75vh - 24px);
  }

  to {
    top: calc(75vh);
  }
}

@keyframes moveDesktop {
  from {
    top: calc(50vh - 24px);
  }

  to {
    top: 50vh;
  }
}

.module-layout {
  position: relative;
  overflow: hidden;

  &.layout-top {
    .layout_head {
      @include media-breakpoint-up("xl") {
        background: transparent;
      }
    }
  }

  .layout_head {
    @include padding-y(10px);
    @include padding-x(18px);
    transition: background 0.3s ease-in-out 0s;
    height: 50px;
    position: fixed;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    background-color: $color-white;

    @include media-breakpoint-up("md") {
      @include padding-y(12px);
      @include padding-x(32px);
      height: 76px;
    }

    .head_logo {
      height: 100%;
      display: flex;
      align-items: center;
      gap: 10px;

      @include media-breakpoint-down("md") {
        height: 25px;
        gap: 8px;
      }

      .logo_divider {
        height: 18px;
        width: 1px;
        background: $color-black;

        @include media-breakpoint-up("md") {
          height: 30px;
        }
      }

      .logo_img {
        height: 100%;
      }

      .logo_cathayholdings {
        cursor: pointer;
        display: flex;
        height: 32px;

        @include media-breakpoint-up("md") {
          height: 51px;
        }
      }

      .logo_cathaylife {
        cursor: pointer;
        display: flex;
        height: 12px;

        @include media-breakpoint-up("md") {
          height: 20px;
        }
      }

      .logo_home {
        cursor: pointer;
        display: flex;
        height: 16px;

        @include media-breakpoint-up("md") {
          height: 27px;
        }
      }
    }

    .head_nav {
      @include padding-right(10px);
      @include font-heading("h6");
      display: flex;
      align-items: center;
      column-gap: 24px;

      @include media-breakpoint-down("lg") {
        font-size: 14px;
        line-height: 1.25;
      }

      .nav_link {
        color: $color-black;
      }

      .nav_toggle {
        @include padding(0);
        display: flex;
        border: none;
        background: transparent;
      }

      &.nav-desktop {
        @include media-breakpoint-down("xl") {
          display: none;
        }
      }

      &.nav-mobile {
        @include media-breakpoint-up("xl") {
          display: none;
        }
      }
    }
  }

  .layout_body {
    @include padding-top(50px);
    width: 100vw;
    overflow-x: hidden;
    min-height: calc(100vh - 76px);

    @include media-breakpoint-up("md") {
      @include padding-top(76px);
    }
  }

  .layout_foot {
    @include padding-x(64px);
    @include padding-top(15px);
    @include padding-bottom(18px);
    flex-direction: column;
    background: rgba($color-white, 0.8);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    @include media-breakpoint-up("md") {
      @include padding(30px);
      flex-direction: row;
    }

    // .foot_logo {
    //   display: flex;

    //   .logo_img {
    //     height: 85px;

    //     @include media-breakpoint-down("md") {
    //       @include margin-bottom(18px);
    //       height: 54px;
    //     }
    //   }
    // }

    .foot_content {
      display: flex;
      flex-direction: column;
      row-gap: 12px;

      // @include media-breakpoint-up("md") {
      //   @include padding-right(12px);
      // }

      .foot_buttonGroup {
        text-align: center;

        @include media-breakpoint-up("md") {
          //   text-align: right;

          .buttonGroup_button {
            & + .buttonGroup_button {
              @include margin-left(10px);
            }
          }
        }

        .buttonGroup_button {
          vertical-align: text-bottom;
          display: inline-flex;

          @include media-breakpoint-down("md") {
            @include margin-x(12px);
          }

          @include media-breakpoint-up("md") {
            & + .buttonGroup_button {
              @include margin-left(10px);
            }
          }
        }
      }
    }

    .foot_copyright {
      @include margin-y(0);
      font-size: 12px;
      line-height: 1.25;
      color: $color-gray-80;
      text-align: center;
      letter-spacing: 0.16em;

      @include media-breakpoint-up("md") {
        font-size: 14px;
        text-align: right;
      }
    }
  }

  .layout_download {
    position: fixed;
    right: 90px;
    bottom: 20px;
    width: 140px;
    height: 140px;
    overflow: visible;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1;

    @include media-breakpoint-down("md") {
      right: 20px;
      width: 112px;
      height: 112px;
    }

    .download_img {
      position: absolute;
      pointer-events: none;
      bottom: -80px;
      right: -80px;

      @include media-breakpoint-down("md") {
        bottom: -63px;
        right: -64px;
        width: 234px;
      }
    }
  }

  .layout_menu {
    @include padding-top(48px);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    width: 100%;
    background: rgba($color-white, 0.95);
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    @include media-breakpoint-up("xl") {
      display: none;
    }

    .menu_nav {
      @include margin-top(34px);

      .nav_link {
        @include margin-y(16px);
        width: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: $color-gray-90;
        font-family: $font-family-n-s-tc;
        font-weight: 500;
        font-size: 18px;
        line-height: 1.25;
        letter-spacing: 0.065em;
        position: relative;

        .link_en {
          font-size: 14px;
        }

        &.link-active {
          color: $color-green-1-d;

          &:before {
            content: "";
            @include margin-right(10px);
            position: absolute;
            right: 100%;
            width: 30px;
            height: 30px;
            background-image: url("../../assets/images/layout/slash-green.svg");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }

          &:after {
            content: "";
            @include margin-left(10px);
            position: absolute;
            left: 100%;
            width: 30px;
            height: 30px;
            background-image: url("../../assets/images/layout/slash-green.svg");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }

    .menu_copyright {
      @include margin-y(24px);
      font-family: $font-family-n-s-tc;
      font-size: 10px;
      line-height: 1.25;
      letter-spacing: 0.16em;
      color: $color-gray-80;
      text-align: center;

      .copyright_en {
        font-family: $font-family-futura;
      }
    }
  }
}
</style>
